import React from "react";
import { REMINDER_LOG_STATUS_COLOR_MAP } from "static/constants";

import { ReactComponent as EmailSuccess } from "../../../assets/svgs/email_success.svg";
import { ReactComponent as EmailError } from "../../../assets/svgs/email_error.svg";
import { ReactComponent as EmailWarning } from "../../../assets/svgs/email_warning.svg";

import { ReactComponent as PhoneSuccess } from "../../../assets/svgs/phone_success.svg";
import { ReactComponent as PhoneError } from "../../../assets/svgs/phone_error.svg";
import { ReactComponent as PhoneWarning } from "../../../assets/svgs/phone_warning.svg";

import { ReactComponent as LetterSuccess } from "../../../assets/svgs/letter_success.svg";
import { ReactComponent as LetterError } from "../../../assets/svgs/letter_error.svg";
import { ReactComponent as LetterWarning } from "../../../assets/svgs/letter_warning.svg";

import { ReactComponent as LiveCallSuccess } from "../../../assets/svgs/live_call_success.svg";
import { ReactComponent as LiveCallError } from "../../../assets/svgs/live_call_error.svg";

import { NotificationsOffOutlined } from "@mui/icons-material";

const ReminderAttemptStatus = ({
  reminderKey,
  reminderAttempts,
  isReminderSubscribed,
  liveCallReminder,
  subscribeSetting,
}) => {
  const reminderTypeIconMapping = {
    email_status: {
      success: <EmailSuccess />,
      error: <EmailError />,
      warning: <EmailWarning />,
    },
    phone_status: {
      success: <PhoneSuccess />,
      error: <PhoneError />,
      warning: <PhoneWarning />,
    },
    letter_status: {
      success: <LetterSuccess />,
      error: <LetterError />,
      warning: <LetterWarning />,
    },
    liveCall: {
      success: <LiveCallSuccess />,
      error: <LiveCallError />,
    },
    noSubscription: {
      default: <NotificationsOffOutlined />,
    },
  };

  const getStatusIcons = (status, key = "noSubscription") => {
    const color = REMINDER_LOG_STATUS_COLOR_MAP[status];
    const reminderTypeIcon = reminderTypeIconMapping[key]?.[color] || null;
    return reminderTypeIcon;
  };

  const getReminderAttemptStatusIcons = () => {
    const attemptKeys = Object.keys(reminderAttempts || {});
    const icons = [];

    if (reminderKey === "live_call" && liveCallReminder) {
      const attemptStatus = liveCallReminder?.status?.toLowerCase();
      const statusIcon = getStatusIcons(attemptStatus, "liveCall");

      icons.push(
        attemptStatus ? (
          <span
            key="live_call"
            style={{ display: "inline-flex", marginRight: 4 }}
          >
            {statusIcon}
          </span>
        ) : (
          <span>—</span>
        )
      );
    }

    if (!subscribeSetting && reminderKey !== "live_call") {
      const statusIcon = getStatusIcons("No Subscription");
      icons.push(
        <span
          key="noSubscription"
          style={{ display: "inline-flex", marginRight: 4 }}
        >
          {statusIcon}
        </span>
      );
    } else {
      for (const key of attemptKeys) {
        const attemptStatus = reminderAttempts[key]?.toLowerCase();
        const statusIcon = getStatusIcons(attemptStatus, key);

        if (statusIcon) {
          icons.push(
            <span key={key} style={{ display: "inline-flex", marginRight: 4 }}>
              {statusIcon}
            </span>
          );
        }
      }
    }
    return icons.length ? icons : <span>—</span>;
  };

  return (
    <div>
      {isReminderSubscribed ? (
        getReminderAttemptStatusIcons()
      ) : (
        <NotificationsOffOutlined fontSize="small" />
      )}
    </div>
  );
};

export default ReminderAttemptStatus;
